export class OrganizationAdminModel {
    public organizationID: number;
    public organizationMasterHashId: string;
    public organizationName: string;
    public personHashID: string;
    public userName: string;
    public firstName: string;
    public lastName: string;
    public isActive: boolean;
    public organizationAdminHashId: string;
    public isChecked: boolean;
    public isUserOrganizationAdmin:boolean;
    public canRemove:boolean;

    constructor() {
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationadmin/models/organizationAdmin.model.ts